import { getClientConfig, getEnvConfig } from 'src/config/config';
import { ModuleID } from 'src/config/types';

export const isModuleEnabled = (module: ModuleID) => !getClientConfig()?.disableModules?.includes(module);
export const usesProviderSso = () => getEnvConfig().USES_PROVIDER_SSO === 'true';
